import { action, makeObservable, observable } from 'mobx';
import { TApproachesListRaw, TSerializedRigOperation } from 'src/api/new-well/types';
import { EventBus } from 'src/shared/utils/event-bus';
import { Directories } from 'src/store/directories/directories.store';

import { Tab } from '../../../../shared/entities/abstract-control-entities';
import { IFormEvents } from '../form.entity';

import { ApproachesList } from './approaches-list.entity';

type ApproachesTabData = {
  formElementRefId: string;
  label?: string;
  approachTemplate: TApproachesListRaw;
  savedApproaches?: TSerializedRigOperation[];
  directories: Directories;
};
export class ApproachesTab extends Tab {
  @observable errorsCount: number;
  @observable isVisuallyDisabled = false;

  eventBus: EventBus<IFormEvents>;
  readonly directories: Directories;
  readonly approachesList: ApproachesList;

  constructor(data: ApproachesTabData, eventBus: EventBus<IFormEvents>) {
    super(data);

    this.directories = data.directories;
    this.approachesList = new ApproachesList(
      {
        directories: data.directories,
        approachesTab: this,
        approachTemplate: data.approachTemplate,
        savedApproaches: data.savedApproaches,
      },
      eventBus,
    );
    this.eventBus = eventBus;
    this.errorsCount = 0;

    makeObservable(this);
  }

  @action.bound
  setIsVisuallyDisabled(is: boolean) {
    this.isVisuallyDisabled = is;
  }

  @action.bound
  addNewApproach(): number {
    return this.approachesList.addNewApproach();
  }

  @action.bound
  validate() {
    this.approachesList.validate();
  }
}

// declare module '../form.entity' {
//   export interface IFormEvents {
//     newRigOperation: Approach;
//     newStage: {
//       rigOperation: Approach;
//       stage: ApproachStage;
//     };
//     newSection: {
//       rigOperation: Approach;
//       stage: ApproachStage;
//       section: ApproachStageSection;
//     };
//     deleteRigOperation: Approach;
//     deleteStage: {
//       rigOperation: Approach;
//       stage: ApproachStage;
//     };
//     deleteSection: {
//       rigOperation: Approach;
//       stage: ApproachStage;
//       section: ApproachStageSection;
//     };
//     updatedRigOperaionList: Approach[];
//     updatedStageList: {
//       rigOperation: Approach;
//       stages: ApproachStage[];
//     };
//     updatedSectionsList: {
//       rigOperation: Approach;
//       stage: ApproachStage;
//       sections: ApproachStageSection[];
//     };
//     initializedRigOperaionList: Approach[];
//     initializedStageList: {
//       rigOperation: Approach;
//       stages: ApproachStage[];
//     };
//     initializedSectionsList: {
//       rigOperation: Approach;
//       stage: ApproachStage;
//       sections: ApproachStageSection[];
//     };
//   }
// }
